/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PlanSettingsPermissionsType from '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PermissionsPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - permissions page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsPermissions: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof PlanSettingsPermissionsType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-permissions", jiraSpaEntry: "async-plan-settings-permissions" */ '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PermissionsPage.tsx'
			),
		),
	{ ssr: false },
);

const AsyncPlanSettingsPermissions = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsPermissions}
		pageId="plan-settings-permissions"
		shouldShowSpinner
	/>
);

export default AsyncPlanSettingsPermissions;
